<template>
  <b-modal
    id="hospitalization-delete-modal"
    content-class="delete-modal-content"
    title="Supprimer un hospitalization"
    @ok="handleOk"
    ok-title="Supprimer"
    ok-variant="danger"
    cancel-title="Annuler"
  >
    <div v-if="selectedHospitalization !== null">
      <div>
        Supprimer l'hospitalisation de "{{selectedHospitalization.animal.name}}" ?
      </div>
      <div>
        Vous allez supprimer toutes les données et chirurgies associées à cette hospitalisation. Cette action est irréversible.
      </div>
    </div>
  </b-modal>
</template>

<script>
import api from '../../services/api';

export default {

  name: 'HospitalizationDeleteModal',

  props: {
    selectedHospitalization: Object
  },

  emits: ['didDeleteHospitalization'],

  methods: {

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    handleSubmit() {

      api
        .delete(`/hospitalization/${this.selectedHospitalization.id}`)
        .then(response => {
          this.$emit('didDeleteHospitalization')
          this.hideModal()
          this.successToast(`Hospitalization supprimée`)
        })
        .catch((error) => {
          if (error.response.status === 418) {
            this.$bvToast.toast(error.response.data.message, {
              autoHideDelay: 2000,
              toaster: 'b-toaster-bottom-right'
            })
          }
        });
    },

    hideModal() {
      this.$bvModal.hide('hospitalization-delete-modal')
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }
  }
}
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/views/hospitalization/HospitalizationDeleteModal.vue